import { render, staticRenderFns } from "./purchaseOverview.vue?vue&type=template&id=43163ce0"
import script from "./purchaseOverview.vue?vue&type=script&lang=js"
export * from "./purchaseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports